import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/ppi/audit-pembersihan-lingkungan";

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

const getKriteria = () => handle(http.getData(`${BASE}/kriteria`));

const getList = (params?: any) =>
  handle(http.getDataParam(`${BASE}/sessions`, params));
const find = (id: number) => handle(http.getData(`${BASE}/sessions/${id}`));
const create = (data: any) => handle(http.postData(`${BASE}/sessions`, data));
const update = (id: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${id}`, data));
const destroy = (id: number) =>
  handle(http.deleteData(`${BASE}/sessions/${id}`));

const bulkResponses = (sessionId: number, responses: any[]) =>
  handle(http.postData(`${BASE}/sessions/${sessionId}/responses/bulk`, { responses }));
const updateResponse = (sessionId: number, responseId: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${sessionId}/responses/${responseId}`, data));

const submitAuditor = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/submit-auditor`, data));
const acknowledgeKaru = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/acknowledge-karu`, data));

const storeTemuan = (sessionId: number, data: any) =>
  handle(http.postData(`${BASE}/sessions/${sessionId}/temuan`, data));
const updateTemuan = (sessionId: number, temuanId: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${sessionId}/temuan/${temuanId}`, data));
const destroyTemuan = (sessionId: number, temuanId: number) =>
  handle(http.deleteData(`${BASE}/sessions/${sessionId}/temuan/${temuanId}`));
const getTemuanTerbuka = (params?: any) =>
  handle(http.getDataParam(`${BASE}/temuan-terbuka`, params));

const getDashboard = (params?: any) =>
  handle(http.getDataParam(`${BASE}/dashboard`, params));

const printPdf = (id: number) => {
  window.open(`${http.getAPI()}${BASE}/sessions/${id}/pdf`, "_blank");
};

export default {
  getKriteria,
  getList,
  find,
  create,
  update,
  destroy,
  bulkResponses,
  updateResponse,
  submitAuditor,
  acknowledgeKaru,
  storeTemuan,
  updateTemuan,
  destroyTemuan,
  getTemuanTerbuka,
  getDashboard,
  printPdf,
};
